var _defs, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgIcContactoActive({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 19.087,
    height: 18.825,
    viewBox: "0 0 19.087 18.825",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, "\n            .cls-1{opacity:.842}.cls-2{fill:#9e9e9e}\n        "))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "ic-contacto-active",
    className: "cls-1",
    transform: "translate(-176.312 -1.065)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Trazado_1812",
    d: "M194.106 8.008a7.362 7.362 0 0 0-7.306-6.943h-.729a7.367 7.367 0 0 0-7.3 6.95 2.26 2.26 0 0 0-1.852 2.213v3.06a2.259 2.259 0 0 0 2.247 2.248h1.534a1.262 1.262 0 0 0 1.261-1.262V9.241a1.262 1.262 0 0 0-1.261-1.262h-.424a5.826 5.826 0 0 1 5.8-5.411h.727a5.83 5.83 0 0 1 5.8 5.411h-.392a1.263 1.263 0 0 0-1.262 1.262v5.033a1.263 1.263 0 0 0 1.262 1.262h.248c-.542 1.443-2.253 2-3.711 2.025a1.534 1.534 0 0 0-1.411-.939h-1.908a1.534 1.534 0 0 0-1.531 1.531v.339a1.4 1.4 0 0 0 1.406 1.4h2.174a1.386 1.386 0 0 0 1.193-.671c2.882-.014 5.051-1.494 5.523-3.728a2.245 2.245 0 0 0 1.808-2.2v-3.067a2.263 2.263 0 0 0-1.896-2.218z",
    className: "cls-2",
    "data-name": "Trazado 1812",
    transform: "translate(-.601)"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIcContactoActive);
export default __webpack_public_path__ + "static/media/ic-contacto-active.ecc1653669cb407b9e81e072ad52f87f.svg";
export { ForwardRef as ReactComponent };